export default {
  nav: {
    main: 'Hoofd',
    ordersAndInvoices: 'Bestellingen en Facturen',
    drafts: 'Concepten',
    automation: 'Automatisering',
    workspace: 'Werkruimte',
    templates: 'Sjablonen',
    delivery: 'Bezorging',
    settings: 'Instellingen',
    shippingLabels: 'Verzendlabels',
    subscriptions: 'Abonnementen',
    support: 'Ondersteuning',
    developer: 'Ontwikkelaar',
    writeReview: 'Schrijf een Beoordeling',
    supportTicket: 'Ondersteuningsticket',
    welcomeTour: 'Welkomstrondleiding',
    administratorConsole: 'Beheerconsole',
    logout: 'Uitloggen',
  },
  dashboard: {
    pageTitle: 'Bestellingen en Facturen',
    pageDescription: 'Manage your orders and invoices',
    title: 'Bestellingen en Facturen',
    selectedOrders: '{count} geselecteerde bestellingen',
    completed: '% voltooid',
    processing: 'Verwerken, even geduld...',
    bulkDownload: 'Bulk Downloaden',
    upgradeBulkDownload: 'Upgrade uw abonnement voor Bulk Downloaden',
    showFilters: 'Filters Tonen',
    hideFilters: 'Filters Verbergen',
    creatingInvoices: 'Facturen aanmaken, even geduld...',
    bulkCreateInvoices: 'Facturen in Bulk Aanmaken',
    cannotCreateAutopilot: 'U kunt geen facturen handmatig aanmaken wanneer de facturatiemodus op automatisch staat.',
    exportInvoices: 'Facturen of bestellingen exporteren',
    capturePayments: 'Betalingen Handmatig Vastleggen',
    filterOrders: 'Bestellingen filteren',
    error: 'Oeps, er is iets misgegaan...',
    close: 'Sluiten',
    chooseDate: 'Kies een datum',
    chooseIssueDate: 'Kies een uitgiftedatum voor de geselecteerde facturen',
    cancel: 'Annuleren',
    createInvoices: 'Facturen Aanmaken',
    storno: 'Storno',
    bulkOrderCapture: 'Bulk Bestelling Vastleggen',
  },
  search: {
    createdBetween: 'Aangemaakt tss.',
    modifiedBetween: 'Gewijzigd tss.',
    orderNumber: 'Bestelling #',
    invoiceNumber: 'Factuur #',
    refundNumber: 'Terugbetaling #',
    customer: 'Klant',
    payment: 'Betaling',
    any: 'Alle',
    authorized: 'Geautoriseerd',
    pending: 'In afwachting',
    paid: 'Betaald',
    partiallyPaid: 'Gedeeltelijk betaald',
    refunded: 'Terugbetaald',
    voided: 'Ongeldig',
    partiallyRefunded: 'Gedeeltelijk terugbetaald',
    unpaid: 'Onbetaald',
    fulfillment: 'Vervulling',
    fulfilled: 'Verzonden',
    partial: 'Gedeeltelijk',
    unfulfilled: 'Niet verzonden',
    loading: 'Bestellingen laden...',
    search: 'Zoeken',
  },
  orderList: {
    noCustomer: 'Geen Klant',
    downloadOrder: 'Bestelling Downloaden',
    deleteWarning: 'Belangrijk! Dit verwijdert alle facturen en terugbetalingen aangemaakt na de datum:',
    includingInvoice: 'inclusief de geselecteerde factuur #',
    pressOk: 'Druk op OK om door te gaan of Annuleren om af te breken.',
    cannotCreateAutopilot: 'U kunt geen facturen handmatig aanmaken wanneer de facturatiemodus op automatisch staat.',
    createInvoice: 'Factuur aanmaken voor deze bestelling',
    create: 'Aanmaken',
    addCreditNote: 'Creditnota Toevoegen',
    createStorno: 'Een Stornofactuur Aanmaken',
    refund: 'Terugbetaling',
    downloadInvoice: 'Deze factuur downloaden',
    download: 'Downloaden',
    default: 'Standaard',
    downloadStorno: 'Deze storno/creditnota downloaden',
    fulfillOrder: 'Bestelling Vervullen',
    orderNum: 'Bestelling #',
    locPrefix: 'Loc Prefix',
    invoiceNum: 'Factuur #',
    refundNum: 'Terugbetaling #',
    customerCol: 'Klant',
    orderCreatedDate: 'Bestelling Aanmaakdatum',
    orderModifiedDate: 'Bestelling Wijzigingsdatum',
    delivered: 'Bezorgd',
    paymentStatus: 'Betalingsstatus',
    fulfillmentStatus: 'Verzendstatus',
    totalOutstanding: 'Totaal Openstaand Bedrag',
    originalPrice: 'Oorspronkelijke Prijs',
    noOrders: 'Uw winkel heeft geen bestellingen voor de geselecteerde status.',
    cannotCreateNoOrders: 'U kunt geen facturen aanmaken als er geen bestellingen zijn.',
    createOrdersFirst: 'Maak ten minste één bestelling aan en probeer opnieuw.',
    createOrders: 'Bestellingen aanmaken',
    loadingOrders: 'Laden...',
    paidManual: 'Betaald - Handmatig',
    paid: 'Betaald',
    refunded: 'Terugbetaald',
    pending: 'In afwachting',
    partiallyPaid: 'Gedeeltelijk betaald',
    partiallyRefunded: 'Gedeeltelijk terugbetaald',
    fulfilled: 'Verzonden',
    unfulfilled: 'Niet verzonden',
    deliveryPending: 'In afwachting',
    deliverNow: 'Nu leveren',
    deliveryPartial: 'Gedeeltelijk',
    notDelivered: 'Niet geleverd',
    deliverAgain: 'Opnieuw leveren',
    deliveryDetails: 'Leveringsdetails',
    deliveryFailed: 'Levering mislukt',
    sent: 'Verzonden',
    failed: 'Mislukt',
    toLabel: 'Aan',
    folderLabel: 'Map',
    open: 'Open',
    invoice: 'Factuur',
    creditNote: 'Creditnota',
    stornoLabel: 'Storno',
    unknown: 'Onbekend',
    googleDrive: 'Google Drive',
    clientsTablet: 'Klanten-tablet',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-mail',
    ftpChannel: 'FTP',
    revertToDate: 'Terugzetten naar deze datum',
    add: 'Toevoegen',
    close: 'Sluiten',
  },
  downloadDialog: {
    downloadType: '{type} downloaden...',
    selectTemplate: 'Selecteer een sjabloon uit de galerij om bestellingen, facturen, stornofacturen of creditnota\'s te exporteren.',
    getMoreTemplates: 'Meer Sjablonen',
    createNewTemplate: 'Nieuw Sjabloon Aanmaken',
    allCreatedBetween: 'Alle aangemaakte {type} tussen',
    selectedType: 'Geselecteerde {type}',
    and: 'en',
    status: 'Status',
    any: 'Alle',
    open: 'Open',
    closed: 'Gesloten',
    cancelled: 'Geannuleerd',
    paymentStatus: 'Betalingsstatus',
    fulfillmentStatus: 'Verzendstatus',
    fulfilled: 'Verzonden',
    partial: 'Gedeeltelijk',
    unfulfilled: 'Niet verzonden',
    authorized: 'Geautoriseerd',
    pending: 'In afwachting',
    paid: 'Betaald',
    partiallyPaid: 'Gedeeltelijk betaald',
    refunded: 'Terugbetaald',
    voided: 'Ongeldig',
    partiallyRefunded: 'Gedeeltelijk terugbetaald',
    unpaid: 'Onbetaald',
    format: 'Formaat',
    forLocation: 'Voor locatie',
    advancedOptions: 'Geavanceerde opties',
    exportHSCodes: 'Inventaris HS-codes exporteren (langzamer)',
    noteChrome: 'Opmerking: Voor optimaal downloaden wordt Chrome aanbevolen en moet een adblocker worden uitgeschakeld.',
    downloadIndividually: 'Individueel downloaden',
    downloadGrouped: 'Gegroepeerd downloaden',
  },
  templates: {
    pageTitle: 'Sjablonen',
    pageDescription: 'Customize your invoice templates',
    title: 'Sjablonen',
    installTranslated: 'Een vertaald sjabloon installeren',
    installTranslatedDesc: 'Kies een andere taal door op deze knop te klikken.',
    createNew: 'Maak indien nodig een nieuw sjabloon aan',
    createNewDesc: 'Klik op deze knop om een nieuw sjabloon aan te maken indien nodig.',
    customize: 'Sjablonen aanpassen',
    customizeDesc: 'Klik op het standaardsjabloon om het aan te passen. U kunt het logo, de kleuren en voor gevorderde gebruikers de code erachter wijzigen.',
    defaultTemplate: 'Factuur, Storno en Creditnota (Standaard)',
    logo: 'Logo',
    colorPalette: 'Kleurenpalet',
    getColorPalettes: 'Kleurenpaletten ophalen',
    paperSize: 'Papierformaat',
    format: 'Formaat',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Rol (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Rol (57.5 x 155 mm)',
    orientation: 'Oriëntatie',
    landscape: 'Liggend',
    portrait: 'Staand',
    margin: 'Marge (cm)',
    unsavedChanges: 'Niet-opgeslagen wijzigingen',
    discard: 'Verwerpen',
    save: 'Opslaan',
  },
  labels: {
    pageTitle: 'Verzendlabels',
    pageDescription: 'Create and manage shipping labels',
    title: 'Verzendlabels',
    glsRequiresPro: 'GLS Verzendlabels voor Oost-Europa vereisen het Professional-abonnement.',
    upgradeDesc: 'Upgrade naar Professional om verzendlabels aan te maken en te beheren.',
    upgradePlan: 'Upgrade uw abonnement',
    eeuGls: 'EEU GLS',
    enabled: 'Ingeschakeld',
    country: 'Land',
    hungary: 'Hongarije',
    slovakia: 'Slowakije',
    czech: 'Tsjechië',
    romania: 'Roemenië',
    slovenia: 'Slovenië',
    croatia: 'Kroatië',
    senderId: 'Verzender-ID',
    username: 'Gebruikersnaam',
    password: 'Wachtwoord',
    name: 'Naam',
    city: 'Stad',
    address: 'Adres',
    zipCode: 'Postcode',
    contactPerson: 'Contactpersoon',
    phone: 'Telefoon',
    email: 'E-mail',
    glsServices: 'GLS Diensten',
    expressService: 'Expresdienst',
    exchangeService: 'Ruildienst',
    smsService: 'SMS-dienst',
    smsText: 'SMS-tekst',
    preAdviceService: 'PreAdvice-dienst',
    unsavedChanges: 'Niet-opgeslagen wijzigingen',
    discard: 'Verwerpen',
    save: 'Opslaan',
  },
  billing: {
    pageTitle: 'Facturering',
    pageDescription: 'Manage your subscription and billing',
    title: 'Facturering',
    subscriptionFor: 'Abonnement voor winkel',
    currentlySubscribed: 'U bent momenteel geabonneerd op het',
    plan: 'abonnement',
    cancelSubscription: 'Abonnement Opzeggen',
    upgradePlan: 'Upgrade uw abonnement',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / maand',
    upgrade: 'Upgraden',
    includesAllStarter: 'Bevat alle Starter-functies, plus:',
    proFeature1: 'Wereldwijde Compliance Suite: Locatiegebaseerde prefixen en aangepaste sequentiële nummering',
    proFeature2: 'Slimme Lokalisatie: Automatisch vertaalde e-mails en gelokaliseerde PDF-bijlagen',
    proFeature3: 'Volledige B2B-documentlevenscyclus: Proforma\'s, B2B-offertes en Creditnota\'s',
    proFeature4: 'B2B-boekhoudsynchronisatie: 3-decimalen eenheidsprecisie en multivaluta-weergave',
    proFeature5: 'Automatische Back-ups: Facturen automatisch kopiëren naar beveiligde FTP of Google Drive',
    proFeature6: 'Shopify Flow: Automatiseer het aanmaken, bezorgen en storneren van facturen via Flow-triggers en -acties',
    proFeature7: 'Geavanceerde AI-logica: Gebruik de on-device AI voor complexe voorwaardelijke lay-outclausules',
    proFeature8: 'UBL XML & ZUGFeRD / Factur-X exports (Europese e-factureringsconformiteit)',
    proFeature9: 'EPC QR-codes voor directe mobiele POS-betalingen',
    proFeature10: 'GLS Verzendlabels voor Oost-Europa',
    proFeature11: '7 jaar fiscale bewaarplicht',
    currentlyUsing: 'U gebruikt momenteel ons',
    free: 'gratis',
    subscriptionPlan: 'abonnement.',
    monthlyUsage: 'Maandelijks Gebruik',
    monthlyGenerated: '{count} / 50 facturen deze maand',
    monthlyLimitReached: 'Maandelijkse limiet bereikt. Upgrade naar Starter voor onbeperkte facturen.',
    freePlan: 'Gratis Abonnement',
    freeToInstall: 'Gratis te installeren',
    freeFeature1: 'Tot 50 facturen/bestellingen per maand',
    freeFeature2: 'Toegang tot alle 31+ voorgedefinieerde sjablonen',
    freeFeature3: 'Basis AI Copilot',
    freeFeature4: 'Standaard PDF-downloads en printen',
    freeFeature5: 'Standaard documentenpakket (Facturen, Pakbonnen, Bonnen)',
    freeFeature6: '3 maanden veilige factuuropslag',
    starterPlan: 'Starter Abonnement',
    starterPrice: '$9.99 / maand',
    starterPricePerInvoice: '+ 3¢ per aangemaakte factuur',
    subscribe: 'Abonneren',
    starterFeature1: 'Onbeperkte facturen en bestellingen',
    starterFeature2: 'Geautomatiseerde PDF-bezorging via e-mail',
    starterFeature3: 'Volledige toegang tot hybride editor en AI Copilot',
    starterFeature4: 'Shopify POS en barcode-integratie',
    starterFeature5: 'Shopify Flow: Triggers en acties voor factuurautomatisering',
    starterFeature6: 'UBL XML / PEPPOL & ZUGFeRD / Factur-X exports (e-factureringsconformiteit)',
    starterFeature7: '1 jaar veilige factuuropslag',
    proTaxOverrides: 'Aangepaste Belastingoverschrijvingen: BTW per product en tarief per SKU',
    unsavedChanges: 'Niet-opgeslagen wijzigingen',
    discard: 'Verwerpen',
    save: 'Opslaan',
  },
  autopilot: {
    pageTitle: 'Automatisering',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatisering',
    autoCreate: 'Facturen Automatisch Aanmaken',
    disabled: 'Uitgeschakeld (Handmatig)',
    whenCreated: 'Wanneer bestellingen worden aangemaakt',
    whenFulfilled: 'Wanneer bestellingen worden vervuld',
    whenPaid: 'Wanneer bestellingen worden betaald',
    autoCreateDesc: 'Facturen worden aangemaakt op de datum waarop bestellingen worden aangemaakt, vervuld of betaald.',
    autoStorno: 'Facturen Automatisch Storneren',
    whenCancelled: 'Wanneer bestellingen worden geannuleerd of terugbetaald',
    autoStornoDesc: 'Stornofacturen worden aangemaakt op de datum waarop bestellingen worden geannuleerd of terugbetalingen worden aangemaakt.',
    cannotAutoFree: 'Facturen automatisch aanmaken is niet mogelijk met het gratis abonnement.',
    upgradePlan: 'Upgrade uw abonnement',
    unsavedChanges: 'Niet-opgeslagen wijzigingen',
    discard: 'Verwerpen',
    save: 'Opslaan',
  },
  delivery: {
    pageTitle: 'Bezorging',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Bezorging',
    settings: 'Instellingen',
    useOrderNumbers: 'Gebruik bestelnummers voor bestanden',
    sendIfCountry: 'Verstuur als het land van het factuuradres is',
    countryCodesHint: 'Vermeld alle landcodes gescheiden door een puntkomma.',
    sendForTags: 'Verstuur voor klanten die een van de vermelde tags hebben',
    tagsHint: 'Vermeld alle tags gescheiden door een puntkomma.',
    emailDelivery: 'E-mailbezorging',
    sendAsPdf: 'Facturen als PDF-bijlage naar klanten versturen',
    autoSend: 'Automatisch versturen wanneer een factuur wordt aangemaakt',
    subject: 'Onderwerp',
    body: 'Inhoud',
    xmlAttachments: 'XML-bijlagen',
    attachUbl: 'UBL/PEPPOL XML bijvoegen (E-Factura)',
    attachZugferd: 'ZUGFeRD / Factur-X XML bijvoegen',
    sendTestEmail: 'Test E-mail Versturen',
    sending: 'Verzenden...',
    customSmtp: 'Aangepaste SMTP-server',
    customSmtpDesc: 'Gebruik uw eigen mailserver in plaats van de standaard',
    enableSmtp: 'Aangepaste SMTP inschakelen',
    smtpHost: 'SMTP Host',
    port: 'Poort',
    useSsl: 'SSL/TLS gebruiken',
    username: 'Gebruikersnaam',
    password: 'Wachtwoord',
    fromEmail: 'Afzender E-mail',
    fromName: 'Afzender Naam',
    shopifyLiquid: 'Shopify Liquid Sjabloon',
    pasteInto: 'Plak dit in uw',
    orderConfirmation: 'orderbevestigingssjabloon',
    toAddLink: 'om een downloadlink toe te voegen.',
    downloadInvoice: 'Download uw factuur',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Verzoeken naar ClientsTablet versturen wanneer facturen worden aangemaakt',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'PDF-facturen als douanedocumenten naar ShippyPro versturen voor niet-EU-landen',
    ftpBackup: 'FTP/SFTP Back-up',
    ftpDesc: 'Facturen automatisch naar uw server kopiëren',
    enableFtp: 'Automatische FTP-back-up inschakelen',
    host: 'Host',
    useSftp: 'SFTP gebruiken (beveiligd)',
    destinationFolder: 'Doelmap',
    xmlFiles: 'XML-bestanden',
    includeUbl: 'UBL/PEPPOL XML bijvoegen (E-Factura)',
    includeZugferd: 'ZUGFeRD / Factur-X XML bijvoegen',
    testConnection: 'Verbinding Testen',
    testing: 'Testen...',
    pro: 'PRO',
    upgradeFtp: 'Upgrade naar Professional om facturen automatisch naar uw FTP/SFTP-server te kopiëren.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Facturen automatisch synchroniseren met uw Drive',
    connected: 'Verbonden',
    disconnect: 'Verbinding Verbreken',
    notWorking: 'Werkt het niet? Ga naar',
    googlePermissions: 'Google Machtigingen',
    removeThenReconnect: 'verwijder Invoice Browse en maak opnieuw verbinding.',
    connectGoogleDrive: 'Google Drive Verbinden',
    upgradeGoogleDrive: 'Upgrade naar Professional om facturen automatisch te synchroniseren met Google Drive.',
    unsavedChanges: 'Niet-opgeslagen wijzigingen',
    discard: 'Verwerpen',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Opslaan',
  },
  bookkeeping: {
    pageTitle: 'Instellingen',
    pageDescription: 'Configure your invoice settings',
    title: 'Instellingen',
    owner: 'Eigenaar',
    email: 'E-mail',
    phone: 'Telefoon',
    keepDifferentNumbering: 'Verschillende factuurnummering per bestelplaats behouden',
    keepDifferentNumberingDisabled: 'Verschillende factuurnummering per bestelplaats is geen optie die beschikbaar is bij uw abonnement.',
    locationEmailDesc: 'Hiermee kunt u e-mails en facturen vertaald versturen op basis van de bestelplaats: voorraadlocatie, verzend- of factuuradres',
    upgradePlan: 'Upgrade uw abonnement',
    matchingCriteria: 'Matchingcriteria',
    locationId: 'Locatie-ID',
    shippingCountryCode: 'Landcode Verzendadres',
    billingCountryCode: 'Landcode Factuuradres',
    matchLocationDesc: 'Match een locatie op basis van bestelplaats-ID, landcode van verzend- of factuuradres.',
    companyInfo: 'Bedrijfsinformatie',
    name: 'Naam',
    website: 'Website',
    registrationNumber: 'Registratienummer',
    taxId: 'Btw-nummer',
    addressSection: 'Adres',
    streetName: 'Straatnaam',
    streetNumber: 'Huisnummer',
    zip: 'Postcode',
    city: 'Stad',
    region: 'Regio',
    country: 'Land',
    bankingInfo: 'Bankgegevens',
    bankName: 'Banknaam',
    swift: 'Swift',
    currency: 'Valuta',
    iban: 'IBAN',
    invoicing: 'Facturering',
    decimalPlaces: 'Decimalen',
    invoicesPrefix: 'Factuurprefix',
    currentInvoiceNumber: 'Huidig Factuurnummer',
    creditNotesPrefix: 'Creditnotaprefix',
    currentCreditNoteNumber: 'Huidig Creditnotanummer',
    lastInvoiceDate: 'Laatste Factuurdatum',
    noInvoicesYet: 'Nog geen facturen aangemaakt.',
    confirmReverting: 'Terugzetten Bevestigen',
    allInvoicesAfter: 'Alle facturen en hun storno\'s uitgegeven na',
    willBeRemoved: 'worden verwijderd. Doorgaan met het terugzetten van het systeem?',
    cancel: 'Annuleren',
    revert: 'Terugzetten',
    revertDesc: 'Het terugzetten van het systeem wist alle facturen die na de geselecteerde datum zijn aangemaakt.',
    revertToDate: 'Terugzetten naar deze datum',
    reverting: 'Systeem terugzetten, even geduld...',
    useOrderNumbering: 'Bestelnummering gebruiken',
    showVat: 'Btw tonen op facturen',
    overrideTaxes: 'Belastingen Overschrijven',
    pricesIncludeTax: 'Prijzen zijn inclusief belasting',
    productsTaxRate: 'Belastingtarief Producten',
    shippingTaxRate: 'Belastingtarief Verzending',
    skusSeparated: 'SKU\'s gescheiden door puntkomma',
    skusTaxRate: 'SKU-belastingtarief',
    useOrderDates: 'Besteldatums gebruiken voor facturen',
    convertCurrency: 'Prijzen omrekenen naar de valuta waarin de klant betaalt',
    unsavedChanges: 'Niet-opgeslagen wijzigingen',
    discard: 'Verwerpen',
    save: 'Opslaan',
  },
  drafts: {
    pageTitle: 'Concepten',
    pageDescription: 'Manage your draft orders',
    title: 'Concepten',
    download: 'Downloaden',
    newDraft: 'Nieuw Concept',
    exporting: 'Exporteren {status}%...',
    accessNotGranted: 'Toegang tot Conceptbestellingen niet verleend. Gelieve',
    reLogin: 'opnieuw in te loggen',
    toGrantPermissions: 'om de vereiste "Conceptbestellingen"-machtigingen te verlenen.',
    pushFailed: 'Push naar Shopify mislukt:',
    exportError: 'Exportfout:',
    confirmDelete: 'Weet u zeker dat u dit concept wilt verwijderen?',
    incompleteCustomer: 'Klantgegevens zijn onvolledig:',
    pushWithoutCustomer: 'Het concept wordt naar Shopify gepusht zonder klantgegevens. Doorgaan?',
    customerNotInShopify: 'Deze klant bestaat nog niet in Shopify.',
    warnings: 'Waarschuwingen:',
    createCustomerAndPush: 'De klant aanmaken in Shopify en het conceptorder pushen?',
    downloadTitle: 'Concepten downloaden',
    cancel: 'Annuleren',
  },
  draftEdit: {
    number: "Nummer",
    prefix: "Voorvoegsel",

    newDraft: 'Nieuw Concept',
    editDraft: 'Concept Bewerken',
    viewInShopify: 'Bekijken in Shopify',
    back: 'Terug',
    createDraft: 'Concept Aanmaken',
    saveChanges: 'Wijzigingen Opslaan',
    documentType: 'Documenttype',
    draftOrder: 'Conceptbestelling',
    quote: 'Offerte',
    proforma: 'Proforma',
    manualInvoice: 'Handmatige Factuur',
    currency: 'Valuta',
    expiryDate: 'Vervaldatum',
    status: 'Status',
    draft: 'Concept',
    sent: 'Verzonden',
    accepted: 'Geaccepteerd',
    customer: 'Klant',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    email: 'E-mail',
    phone: 'Telefoon',
    company: 'Bedrijf',
    taxId: 'Btw-nummer',
    billingAddress: 'Factuuradres',
    address: 'Adres',
    aptSuite: 'Apt/Suite',
    city: 'Stad',
    province: 'Provincie',
    countryField: 'Land',
    zip: 'Postcode',
    shippingAddress: 'Verzendadres',
    sameAsBilling: 'Zelfde als factuuradres',
    lineItems: 'Regelitems',
    shipping: 'Verzending',
    shippingTitle: 'Titel',
    shippingPlaceholder: 'bijv. Standaard Verzending',
    price: 'Prijs',
    note: 'Opmerking',
    notePlaceholder: 'Interne opmerking of bericht aan klant...',
    summary: 'Samenvatting',
    subtotal: 'Subtotaal',
    discounts: 'Kortingen',
    tax: 'Belasting',
    total: 'Totaal',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Voer uw winkeladres in',
    loginWith: 'Inloggen met',
    createAccount: 'Een nieuw account aanmaken',
    placeholder: 'uw-winkelnaam',
    shopRequired: 'Winkelnaam is vereist',
    login: 'Inloggen',
    shopify: 'Shopify',
    terms: 'Algemene Voorwaarden',
    privacy: 'Privacybeleid',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Bevalt Invoice Browse?',
    description: 'U heeft uw eerste facturen aangemaakt! Als u de app nuttig vindt, helpt een snelle beoordeling op de Shopify App Store ons enorm.',
    reward: 'Als dank zetten we uw maandelijkse gebruiksteller terug op 0',
    leaveReview: 'Beoordeling Achterlaten',
    maybeLater: 'Misschien later',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Welkom bij Invoice Browse',
    welcomeContent: 'Laat me u tonen hoe u het kunt gebruiken.',
    dashboardTitle: 'Dashboard',
    dashboardContent: 'Het scherm dat u ziet is het hoofddashboard. Hier vindt u alle bestellingen en kunt u ze exporteren naar verschillende documenttypen zoals: facturen, pakbonnen en andere.',
    automationTitle: 'Maak uw leven makkelijker',
    automationContent: 'Schakel automatisering in om facturen aan te maken wanneer bestellingen worden betaald of terugbetaald.',
    templatesTitle: 'Sjablonen aanpassen',
    templatesContent: 'Ga hier naar binnen om uw sjabloon te vertalen, aan te passen of een nieuw sjabloon te maken.',
    deliveryTitle: 'Bezorging',
    deliveryContent: 'Configureer onze app om aangemaakte documenten automatisch te kopiëren naar FTP, Google Drive, of als bijlagen bij e-mails.',
    settingsTitle: 'Instellingen',
    settingsContent1: 'Pas het telefoonnummer, e-mailadres en andere velden van het bedrijf aan die op documenten worden gebruikt.',
    settingsContent2: 'Wijzig het startnummer van documenten of wis documenten die na een bepaalde datum zijn aangemaakt.',
    settingsContent3: 'Overschrijf btw-tarieven voor verzending en producten',
    settingsContent4: 'Wijzig het aantal decimalen voor getallen',
    reviewTitle: 'Schrijf een beoordeling',
    reviewContent: 'Steun ons team door een goede beoordeling te schrijven!',
    tourTitle: 'Welkomstrondleiding',
    tourContent: 'Hé, u kunt deze rondleiding opnieuw openen vanaf hier.',
    createDocTitle: 'Maak uw eerste document aan',
    createDocContent: 'Klik op de knop Aanmaken om uw eerste document aan te maken.',
    docNumberTitle: 'Documentnummer',
    docNumberContent: 'Het eerste document heeft nummer 1 toegewezen gekregen. Als u met een ander nummer wilt beginnen, kunt u dit wijzigen in Instellingen.',
    downloadDocTitle: 'Document downloaden',
    downloadDocContent: 'Klik op het Download-dropdown en selecteer een documentsjabloon om uw bestelling als PDF te exporteren.',
  },
  common: {
    save: 'Opslaan',
    cancel: 'Annuleren',
    close: 'Sluiten',
    discard: 'Verwerpen',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    create: 'Aanmaken',
    loading: 'Laden...',
    unsavedChanges: 'Niet-opgeslagen wijzigingen',
    upgradePlan: 'Upgrade uw abonnement',
  },
  languageSelector: {
    label: 'Taal',
    auto: 'Automatisch detecteren',
  },
  draftList: {
    draftNum: 'Concept #',
    shopifyId: 'Shopify ID',
    type: 'Type',
    customer: 'Klant',
    total: 'Totaal',
    status: 'Status',
    delivered: 'Afgeleverd',
    date: 'Datum',
    actions: 'Acties',
    noCustomer: 'Geen klant',
    noDrafts: 'Geen concepten of offertes gevonden.',
    loading: 'Laden...',
    download: 'Downloaden',
    default: 'Standaard',
    pending: 'In afwachting',
    deliverNow: 'Nu leveren',
    deliveryDetails: 'Leveringsdetails',
    sent: 'Verzonden',
    failed: 'Mislukt',
    deliverAgain: 'Opnieuw leveren',
    partial: 'Gedeeltelijk',
    notDelivered: 'Niet afgeleverd',
    deliveryFailed: 'Levering mislukt',
    unknown: 'Onbekend',
    edit: 'Bewerken',
    send: 'Verzenden',
    pushToShopify: 'Naar Shopify sturen',
    complete: 'Voltooien',
    duplicate: 'Dupliceren',
    delete: 'Verwijderen',
    quote: 'Offerte',
    proforma: 'Proforma',
    draftOrder: 'Conceptbestelling',
    manualInvoice: 'Handmatige factuur',
  },
  draftSearch: {
    createdBtw: 'Aangemaakt tss.',
    draftNum: 'Concept #',
    shopifyId: 'Shopify ID',
    customer: 'Klant',
    status: 'Status',
    type: 'Type',
    delivery: 'Levering',
    any: 'Alle',
    draft: 'Concept',
    sent: 'Verzonden',
    accepted: 'Geaccepteerd',
    expired: 'Verlopen',
    converted: 'Geconverteerd',
    cancelled: 'Geannuleerd',
    quote: 'Offerte',
    proforma: 'Proforma',
    draftOrder: 'Conceptbestelling',
    manualInvoice: 'Handmatige factuur',
    delivered: 'Afgeleverd',
    notDelivered: 'Niet afgeleverd',
    pending: 'In afwachting',
    search: 'Zoeken',
  },
  draftDownload: {
    title: 'Concepten & offertes downloaden...',
    selectTemplate: 'Selecteer een sjabloon uit de galerij om concepten, offertes of proforma\'s te exporteren.',
    allDraftsBetween: 'Alle concepten tussen',
    selectedDrafts: 'Geselecteerde concepten',
    and: 'en',
    status: 'Status',
    documentType: 'Documenttype',
    any: 'Alle',
    draft: 'Concept',
    sent: 'Verzonden',
    accepted: 'Geaccepteerd',
    expired: 'Verlopen',
    converted: 'Geconverteerd',
    cancelled: 'Geannuleerd',
    quote: 'Offerte',
    proforma: 'Proforma',
    draftOrder: 'Conceptbestelling',
    manualInvoice: 'Handmatige factuur',
    format: 'Formaat',
    noTemplates: 'Geen sjablonen gevonden',
    noTemplatesForType: 'Geen sjablonen gevonden voor documenttype "{type}".',
    installTemplates: 'Sjablonen installeren',
    toStartExporting: 'om te beginnen met exporteren.',
    noteChrome: 'Opmerking: Voor optimaal downloaden wordt Chrome aanbevolen en moet elke adblocker uitgeschakeld zijn.',
    cancel: 'Annuleren',
    downloadIndividually: 'Individueel downloaden',
    downloadGrouped: 'Gegroepeerd downloaden',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Nieuw sjabloon installeren',
    tabStyle: 'Stijl',
    tabContent: 'Inhoud',
    tabTranslations: 'Vertalingen',
    tabSettings: 'Instellingen',
    tabCode: 'Code',
    tabCopilot: 'AI-Copiloot',
    logo: 'Logo',
    colorPalette: 'Kleurenpalet',
    colorText: 'Tekst',
    colorBg: 'Achtergrond',
    colorBorder: 'Rand',
    colorPrimary: 'Primair',
    colorAccent: 'Accent',
    font: 'Lettertype',
    fontDefault: 'Standaard (DM Sans)',
    fontSize: 'Lettergrootte',
    fontSizeDefault: 'Standaard (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Klein',
    fontSizeMediumSmall: 'Middel-klein',
    fontSizeMedium: 'Middel',
    fontSizeMediumLarge: 'Middel-groot',
    fontSizeLarge: 'Groot',
    fontSizeExtraLarge: 'Extra groot',
    documentTitle: 'Documenttitel',
    documentTitlePlaceholder: 'bijv. Factuur, Belastingfactuur...',
    noToggleSupport: 'Dit sjabloon ondersteunt geen schakelaars. Schakel over naar een galerij-sjabloon voor volledige aanpassing.',
    sections: 'Secties',
    shippingAddress: 'Verzendadres',
    bankPaymentDetails: 'Bank-/betalingsgegevens',
    paymentStatusBadge: 'Betalingsstatusbadge',
    orderNotes: 'Bestelnotities',
    trackingFulfillment: 'Tracking/verzending',
    termsConditions: 'Algemene voorwaarden',
    signatureLines: 'Handtekeningregels',
    qrCode: 'QR-code',
    lineItems: 'Regelitems',
    taxColumns: 'Belastingkolommen (BTW)',
    productSku: 'Product-SKU',
    productImages: 'Productafbeeldingen',
    discountBreakdown: 'Kortingsoverzicht',
    itemWeight: 'Artikelgewicht',
    hsCode: 'HS-code (douane)',
    mergeDiscounts: 'Kortingen samenvoegen in productprijs',
    showOrderDiscountAsSummary: 'Toon orderkorting als samenvattingsregel',
    totals: 'Totalen',
    subtotalBeforeTax: 'Subtotaal (voor belasting)',
    taxBreakdownByRate: 'Belastingoverzicht per tarief',
    shippingCostSeparate: 'Verzendkosten als aparte regel',
    dueDate: 'Vervaldatum',
    formatting: 'Opmaak',
    dateFormat: 'Datumformaat',
    decimalPlaces: 'Decimalen',
    paymentTerms: 'Betalingsvoorwaarden',
    paymentTermsNone: 'Geen',
    thankYouMessage: 'Bedankbericht',
    thankYouPlaceholder: 'Bedankt voor uw aankoop!',
    countryMatchTitle: 'Dit sjabloon gebruiken wanneer het verzend- of factuuradres overeenkomt met dit land',
    addressType: 'Adrestype',
    addressDisabled: 'Uitgeschakeld',
    addressShipping: 'Verzendadres',
    addressBilling: 'Factuuradres',
    country: 'Land',
    anyCountry: 'Elk land',
    countryMatchDesc: 'Wanneer ingeschakeld wordt dit sjabloon automatisch gebruikt voor bestellingen waarbij het geselecteerde adres overeenkomt met het gekozen land.',
    languagePreset: 'Taalinstelling',
    selectLanguage: 'Selecteer een taal...',
    languagePresetDesc: 'Het selecteren van een taal vult alle labels hieronder in. U kunt daarna individuele velden aanpassen.',
    paperSize: 'Papierformaat',
    format: 'Formaat',
    orientation: 'Oriëntatie',
    portrait: 'Staand',
    landscape: 'Liggend',
    margin: 'Marge (cm)',
    template: 'Sjabloon',
    templateName: 'Naam',
    systemAlias: 'Systeemalias',
    systemAliasDesc: 'voor POS/Admin URL-routes',
    systemAliasNone: 'Geen',
    defaultTemplate: 'Standaard sjabloon',
    defaultTemplateDesc: 'Gebruikt voor directe links gedeeld met klanten.',
    posRouteDesc: 'Mapt naar /template/[alias]/receipt.pdf voor POS-integratie.',
    documentType: 'Documenttype',
    invoiceCreditNote: 'Factuur + Creditnota',
    order: 'Bestelling',
    invoiceOnly: 'Alleen factuur',
    quoteEstimate: 'Offerte/Schatting',
    proformaInvoice: 'Proforma-factuur',
    refund: 'Terugbetaling',
    stornoInvoice: 'Stornofactuur',
    creditNoteOnly: 'Alleen creditnota',
    reportLiquid: 'Rapport (alleen Liquid)',
    hideRemovedItems: 'Verwijderde/terugbetaalde items verbergen',
    location: 'Locatie',
    locationEmpty: 'Laat leeg om voor alle locaties te gebruiken',
    dangerZone: 'Gevarenzone',
    dangerZoneDesc: 'Dit sjabloon permanent uit uw account verwijderen.',
    removeTemplate: 'Sjabloon verwijderen',
    bodyTemplate: 'Body-sjabloon',
    bodyTemplateDesc: 'Gebruikt Mustache- of Liquid-syntaxis. Klik op een snippet:',
    rowTemplate: 'Rijsjabloon',
    rowTemplateDesc: 'Eenmaal gerenderd per item. Klik op een snippet:',
    variableReference: 'Variabelenreferentie',
    formatCode: 'Code formatteren',
    insert: 'Invoegen',
    copy: 'Kopiëren',
    loadModelContinue: 'Model laden en doorgaan',
    cancel: 'Annuleren',
    copilotPlaceholder: 'Probeer: vertaal naar Nederlands, toon belastingkolommen, voeg barcode toe...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Ongedaan maken',
    redo: 'Opnieuw',
    aiThinking: 'AI denkt na...',
    proposedChanges: 'Voorgestelde wijzigingen',
    applyChanges: 'Wijzigingen toepassen',
    dismiss: 'Negeren',
    aiEngineReady: 'AI-engine gereed',
    loadingAiModel: 'AI-model laden...',
    aiEngineOff: 'AI-engine uit —',
    loadForAdvanced: 'laden voor geavanceerde bewerking',
    instantCommands: 'vertalen, secties tonen/verbergen, snippets toevoegen, lettertype/kleuren/papier wijzigen',
    aiEngineDesc: 'structurele HTML-bewerkingen, lay-outwijzigingen, aangepaste modificaties',
    aiLocalDesc: 'Model draait lokaal via WebGPU — geen data verlaat uw browser.',
    aiUpgradeDesc: 'upgrade naar Starter of Professional voor geavanceerde AI-sjabloonbewerking.',
    upgrade: 'Upgraden',
    loadAiQuestion: 'AI-engine laden?',
    loadAiDesc: 'Het AI-model wordt gedownload en lokaal uitgevoerd via WebGPU. Vereist ~1-3 GB vrij VRAM/RAM en een moderne GPU.',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/nl.js